<!--
component: ListKosakuAddress
author: Ken Nakamura
description: 昇降機住所検索結果リスト
-->
<template>
  <section>
    <v-data-table
      :headers="headers" :items="daichoList"
      :fixed-header="false" height="calc(100vh - 20em)"
      mobile-breakpoint="0"
      disable-pagination hide-default-footer dense
      :single-select="true" item-key="daichoId"
      :search="search"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items"
            @click="selectRow(item, index)"
            :id="item.id"
            :key="index"
            :class="{selected:item.active}"
            class="default"
          >
            <td>{{transform_flg_kakutei(item.flg_kakutei)}}</td>
            <td>{{transform_done_kakutei(item.data_kknnzumi)}}</td>
            <td>{{transform_annotation(item.annotation)}}</td>
            <td>{{transform_bkn_sybt(item.bkn_sybt)}}</td>
            <td>{{transform_stop_sybt(item.stop_sybt)}}</td>
            <td>{{transform_bango(item)}}</td>
            <td>{{transform_bkn_addr1(item.bkn_addr1)}}</td>
            <td>{{transform_bldr_addr1(item.bldr_addr1)}}</td>
            <td>{{transform_bldr_name1(item.bldr_name1)}}</td>
            <td>{{transform_syuyo_yoto(item.gutai_syuyo_yoto)}}</td>
            <td>{{transform_kozo_sybt(item.gutai_kozo_sybt)}}</td>
            <td>{{transform_gutai_koji_sybt(item.gutai_koji_sybt)}}</td>
            <td>{{transform_tijo_kaisu(item.tijo_kaisu)}}</td>
            <td>{{transform_tika_kaisu(item.tika_kaisu)}}</td>
<!--
            <td>{{item.ukeNo}}</td>
            <td>{{dateTextToWareki(item.ukeDay)}}</td>
            <td>{{item.kknnNo}}</td>
            <td>{{dateTextToWareki(item.kknnDay)}}</td>
            <td>{{item.addr}}</td>
            <td>{{item.nameKanji}}</td>
-->
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { dbglog, dateTextToWareki, /*getSyuyoName,*/ getGutaiSyuyoYotoName, getWardCodeBalicsShortname, getStopSybtName } from '../common/utils'

export default {
  data: () => {
    return {
      headers: [
        {
          text: '確定',
          value: 'item1'
        },
        {
          text: '確認済',
          value: 'item2'
        },
        {
          text: 'コメント',
          value: 'item3'
        },
        {
          text: '物件種別',
          value: 'item4'
        },
        {
          text: '取止め・取下げ等',
          value: 'item5'
        },
        {
          text: '確認申請番号',
          value: 'item6'
        },
        {
          text: '物件所在地',
          value: 'item7'
        },
        {
          text: '建築主住所',
          value: 'item8'
        },
        {
          text: '建築主氏名',
          value: 'item9'
        },
        {
          text: '主用途',
          value: 'item10'
        },
        {
          text: '構造',
          value: 'item11'
        },
        {
          text: '工事種別',
          value: 'item12'
        },
        {
          text: '地上階数',
          value: 'item13'
        },
        {
          text: '地下階数',
          value: 'item14'
        },
      ],
      search: "",
    }
  },
  props: {
  },
  mounted () {
    this.search = "";
//    this.scrollToSelection();
    this.$nextTick(() => { this.scrollToSelection(); });
  },
  computed: {
    selectedNo: {
      get() { return this.$store.state.selectedNo; },
      set(val) { this.$store.commit('setSelectedNo', val); }
    },
    selectedId: {
      get() { return this.$store.state.selectedId; },
      set(val) { this.$store.commit('setSelectedId', val); }
    },
    daichoList() {
      var datas =  this.$store.state.daicho;
      if(this.search == "") {
        return datas;
      } else {
        var text = this.search;
        let filteredDatas = [];
        for (let i = 0; i < datas.length; i++) {
          let item = datas[i];
          if(this.transform_flg_kakutei(item.flg_kakutei).includes(text)
          || this.transform_done_kakutei(item.data_kknnzumi).includes(text)
          || this.transform_annotation(item.annotation).includes(text)
          || this.transform_bkn_sybt(item.bkn_sybt).includes(text)
          || this.transform_stop_sybt(item.stop_sybt).includes(text)
          || this.transform_bango(item).includes(text)
          || this.transform_bkn_addr1(item.bkn_addr1).includes(text)
          || this.transform_bldr_addr1(item.bldr_addr1).includes(text)
          || this.transform_bldr_name1(item.bldr_name1).includes(text)
          || this.transform_syuyo_yoto(item.gutai_syuyo_yoto).includes(text)
          || this.transform_kozo_sybt(item.gutai_kozo_sybt).includes(text)
          || this.transform_gutai_koji_sybt(item.gutai_koji_sybt).includes(text)
          || this.transform_tijo_kaisu(item.tijo_kaisu).toString().includes(text)
          || this.transform_tika_kaisu(item.tika_kaisu).toString().includes(text)
          ) {
            filteredDatas.push(item);
          }
        }
        return filteredDatas;
      }
    },
  },
  methods: {
    /**
     * 日付の和暦変換
     * @param {Date} date 変換する日付
     * @return {String} 和暦表現に変換された文字列を返す
     */
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from utils.js
    },
    /**
     * 一覧でクリックされた行を選択
     * @param {GaiyoSummary} target 選択する概要データ
     */
    selectRow (target, index) {
      dbglog(index);
      var daicho_list = this.$store.state.daicho;
      var sel_index = daicho_list.indexOf(target);
      this.$store.commit('setSeldaichoindex', sel_index);
      this.$store.commit('setSeldaicho', target);

      daicho_list.forEach((k) => {
//        k.active = (k === target);
        this.$set(k, 'active', k === target);
      });

      this.$emit('call-parent-method');
    },
    /**
     * 選択されている物件がリスト中央に表示されるようにスクロールする
     */
    scrollToSelection () {
			var daicho_list = this.$store.state.daicho;
			var daicho_index = this.$store.state.seldaichoIndex;
			var daicho_item = daicho_list[daicho_index];

      const selectedRow = document.getElementById(daicho_item.id);
      if (selectedRow) {
        // 選択された行が表示されるようにスクロールする
        selectedRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

//      tr.scrollIntoView({ block: 'center' });
    },
    transform_flg_kakutei(value) {
      return value === 0 ? '-' : (value === 1 ? '確定' : '-');
    },
    transform_done_kakutei(value) {
      return value === 0 ? '-' : (value === 1 ? '確認済' : '-');
    },
    transform_annotation(value) {
      return (value === "" || value === null || value === undefined) ? "-" : value;
    },
    transform_bkn_sybt(value) {
      return getGutaiSyuyoYotoName(value);
    },
    transform_stop_sybt(value) {
//      return value === 0 ? '無効' : (value === 1 ? '有効' : '-');
      return getStopSybtName(value);
    },
    transform_bango(item) {
      return item.nen +getWardCodeBalicsShortname(item.gyosei_kubun)+ item.bango;
//      return value;
//      return (value === "" || isNaN(value) || value === null || value === undefined) ? "-" : value;
    },
    transform_bkn_addr1(value) {
      return (value === "" || value === null || value === undefined) ? "-" : value;
    },
    transform_bldr_addr1(value) {
      return (value === "" || value === null || value === undefined) ? "-" : value;
    },
    transform_bldr_name1(value) {
      return (value === "" || value === null || value === undefined) ? "-" : value;
    },
    transform_syuyo_yoto(value) {
      return (value === "" || value === null || value === undefined) ? "" : value;
      //value = getSyuyoName(value);
      //return value;
    },
    transform_kozo_sybt(value) {
      return (value === "" || value === null || value === undefined) ? "" : value;
//      return value;
    },
    transform_gutai_koji_sybt(value) {
      return (value === "" || value === null || value === undefined) ? "" : value;
//      return value;
    },
    transform_tijo_kaisu(value) {
      return isNaN(Number(value)) ? 0 : Number(value);
    },
    transform_tika_kaisu(value) {
      return isNaN(Number(value)) ? 0 : Number(value);
    },
  },  
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>